import { z } from "zod";
import { RoleSchema, ClearanceSchema } from "./enums.js";

export const User = z.object({
  id: z.number().int().positive(),
  email: z.string().email(),
  name: z.string(),
  role: RoleSchema,
  clearance: ClearanceSchema,
  active: z.boolean(),
  initials: z.string().nullable(),
});
export type User = z.infer<typeof User>;

export const UserCreate = z.object({
  email: z.string().email(),
  name: z.string().min(1).max(200),
  role: RoleSchema,
  clearance: ClearanceSchema.optional().default("intern"),
  initials: z.string().min(1).max(20).nullable().optional(),
  active: z.boolean().optional().default(true),
});
export type UserCreate = z.infer<typeof UserCreate>;

export const UserUpdate = z.object({
  name: z.string().min(1).max(200).optional(),
  role: RoleSchema.optional(),
  clearance: ClearanceSchema.optional(),
  initials: z.string().min(1).max(20).nullable().optional(),
  active: z.boolean().optional(),
});
export type UserUpdate = z.infer<typeof UserUpdate>;

export const ResetPassword = z.object({ newPassword: z.string().min(8) });
export type ResetPassword = z.infer<typeof ResetPassword>;
